import HomeLayout from '@/layouts/Home.vue'
import Report from './Report.vue'
import VacationReport from './components/VacationReport.vue'
import LettersReport from './views/lettersReport.vue'

export const reportRoutes = [
  {
    path: '/reports',
    name: 'Reports',
    component: Report,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/reports/vacations',
    name: 'VacationReport',
    component: VacationReport,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/reports/letters',
    name: 'lettersReports',
    component: LettersReport,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin', 'admin'],
    },
  },
]
